// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__eLJfL","footerNav":"Navigation_footerNav__MVvLm"};